import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledContactForm = styled.section`
    position: relative;
    padding: 120px 0;

    .job-conetent {
        blockquote {
            padding: 18px 25px;
            opacity: 0.92;
            background: rgba(150, 125, 62, 0.28);
            color: #886C37;
            font-size: 0.9rem;
            font-style: normal;
            font-weight: 300;
            line-height: 1.377rem;
            letter-spacing: -0.027rem;
            margin: 60px 0;
        }

        .round-list {
            margin-top: 40px;
            list-style: none;

            li {
                border-bottom: 1px solid rgba(21, 38, 55, 0.2);
                padding-bottom: 10px;
                margin-bottom: 10px;
                color: #152637;
                font-weight: 400;
                font-size: 1rem;
                line-height: 1.5rem;
                letter-spacing: 0;
                position: relative;
                counter-increment: count;
                padding-left: 32px;
                list-style: none;

                h3 {
                    font-weight: 400;
                    font-size: 1.25rem;
                    line-height: 1.5rem;
                    letter-spacing: 0;
                    margin-bottom: 10px;
                }

                p {
                    margin: 0;
                }

                &:before {
                    width: 20px;
                    height: 20px;
                    background: #DD223F;
                    content: counter(count, decimal);
                    font-weight: 400;
                    font-size: 0.625rem;
                    line-height: 0.75rem;
                    letter-spacing: 0;
                    text-align: center;
                    position: absolute;
                    color: white;
                    left: 0;
                    top: 5px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }

        ul {
            list-style: disc;
            padding-left: 15px;
            margin-bottom: 60px;

            li {
                list-style: disc;
                font-size: 1rem;
                font-style: normal;
                font-weight: 400;
                line-height: 1.53rem;
                letter-spacing: -0.023rem;
                margin-bottom: 10px;

                ::marker {
                    color: #DD223F;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
        h3 {
            margin-bottom: 20px;
        }

        p {
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.5rem;
            letter-spacing: 0;
            margin-bottom: 20px;

            span {
                color: #DD223F;
            }
        }
        table {
            width: 100%;
            border-collapse: collapse;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.5rem;
            letter-spacing: 0;
            color: #394149;
            margin-bottom: 60px;
        }

        tr {
            display: flex;
        }

        th, td {
            width: 50%; /* Each cell takes 50% */
            border-bottom: 1px solid rgba(21, 38, 55, 0.2); /* Light gray border */
            padding: 20px 0 20px;
            text-align: left;
        }

        th {
            font-weight: 700;
            padding-top: 0;
            border-bottom: 1px solid #152637; /* Light gray border */

        }

        tr:nth-child(even) {
        }

        tr:hover {
        }

        caption {
            font-size: 1.2rem;
            font-weight: 600;
            margin-bottom: 10px;
            color: #886C37;
        }

    }

    .close-button-ygen {
        position: absolute;
        top: 40px;
        right: 40px;
        z-index: 999;
    }

    &.asModal {
        background: white;
        position: absolute;
        inset: 0;
        height: 100%;
        width: 100%;
        margin: 0;
    }

    .fix-left {
        position: absolute;
        left: 40px;
        top: 295px;
        will-change: transform;

        h3 {
            font-size: 15rem !important; /* 300px / 20px = 15rem */
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            letter-spacing: -0.75rem !important; /* -15px / 20px = -0.75rem */
        }
    }

    .fix-right {
        position: absolute;
        right: -40px;
        top: 95px;
        will-change: transform;

        h3 {
            color: rgba(21, 38, 55, 0.03);

        }
    }

    .fix-it {
        z-index: 0;
        position: absolute;
        left: -18%;
        top: -40%;
        opacity: 0.7;
        will-change: transform;

        h3 {
            color: rgba(21, 38, 55, 0.03);

        }
    }

    @keyframes bounce {
        0%, 100% {
            transform: translateY(0);
            animation-timing-function: ease-in-out;
        }
        50% {
            transform: translateY(-3px);
            animation-timing-function: ease-in;
        }
    }

    .d-flex {
        display: flex;
        flex-direction: column;
        position: relative;
        z-index: 3;

        .single-item {
            display: flex;
            gap: 30px;
            margin-bottom: 60px;

            svg {
                path {
                    transition: ${theme.transition};
                }
            }

            p {
                color: #152637;
                font-size: 1rem; /* 16px / 16 */
                font-style: normal;
                font-weight: 400;
                line-height: 1.5rem; /* 24px / 16 */

            }

            a {
                color: #152637;
                font-size: 1.25rem; /* 20px / 16 */
                font-style: normal;
                font-weight: 700;
                line-height: 1.5rem; /* 24px / 16 */
            }

            &:last-child {
                margin-bottom: 0;
            }

            svg {
                path {
                    transition: ${theme.transition};
                }
            }

            &:hover {
                svg {
                    path {
                        animation: bounce 1s infinite;
                    }
                }
            }
        }
    }

    .image-wrapper-map {
        position: relative;
        padding-top: calc(561 /
        1096 * 100%);
        width: 85%;
        margin-left: auto;
        background: transparent;
        margin-top: 170px;

        .parrlax-img-left {
            position: absolute;
            top: -74px;
            left: -85px;
            z-index: 9;
        }
    }

    @media(max-width: 992px){

        .list_with_form{
            margin-top: 40px;
        }
        .fix-left {
            position: absolute;
            left: 40px;
            top: 295px;
            will-change: transform;

            h3 {
                font-size: 10rem !important; /* 300px / 20px = 15rem */
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                letter-spacing: -0.75rem !important; /* -15px / 20px = -0.75rem */
            }
        }

        .fix-right {
            position: absolute;
            right: 40px;
            top: 95px;
            will-change: transform;

            h3 {
                font-size: 10rem !important; /* 300px / 20px = 15rem */
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                letter-spacing: -0.75rem !important; /* -15px / 20px = -0.75rem */
            }
        }
    }

    @media(max-width: 767px){
        .fix-it, .parrlax-img-left{
            display: none;
        }

        .image-wrapper-map{
            width: 100%;
            margin-top: 80px;
        }
    }
`;
